<mat-dialog-content>
  <section class="text-[#353C40] flex flex-col gap-5">
    <h3 class="text-center text-[1.6rem] font-semibold tracking-tight">
      ⚠️ Lock Section
    </h3>
    <p class="text-left text-[.85rem] font-medium">
      Are you sure you want to lock this section?
    </p>
    <p class="text-left text-[.85rem] font-medium">Do you want to proceed?</p>
  </section>
</mat-dialog-content>
<mat-dialog-actions class="flex flex-col md:flex-row gap-7 w-full">
  <button class="md w-full md:flex-1" mat-dialog-close mat-stroked-button>
    Cancel
  </button>
  <button [mat-dialog-close]="true" class="md w-full md:flex-1" mat-flat-button>
    Lock
  </button>
</mat-dialog-actions>
